import React from 'react'
var ShopHeaders={
    backgroundImage: 
    "url('/images/BannerImages/shophero.jpg')",
    marginTop:"0px"
  }
export default function ShopHeader() {
  return (
    <>
     <section id="Shopping_hero" style={ShopHeaders}>
        <h2>#StayHome</h2>    
        <p>Save more with coupons and upto 70% off</p>


    </section>    
    </>
  )
}
